// extracted by mini-css-extract-plugin
export default {"container":"Header_container__DFFf6","way":"Header_way__ly-+6","title":"Header_title__iU1zv","image":"Header_image__OwYHB","par":"Header_par__NQspf"};